




import Vue from 'vue';
import Component from 'vue-class-component';
import NewCurve from '@/pages/schedules/components/curves/NewCurve.vue';

@Component({
  components: {
    NewCurve
  }
})
class CreateCurve extends Vue{
}

export default CreateCurve;
